import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SpreadsheetGuide from "../pages/hipobuy-spreadsheet-guide/page";
import HipobuyVsKakobuy from "../pages/hipobuy-vs-kakobuy/page";
import HipobuyVsCSSBuy from "../pages/hipobuy-vs-cssbuy/page";
import HipobuyVsSuperbuy from "../pages/hipobuy-vs-superbuy/page";
import HipobuyVsOopbuy from "../pages/hipobuy-vs-oopbuy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-spreadsheet-guide",
    element: <SpreadsheetGuide />,
  },
  {
    path: "/hipobuy-vs-kakobuy",
    element: <HipobuyVsKakobuy />,
  },
  {
    path: "/hipobuy-vs-cssbuy",
    element: <HipobuyVsCSSBuy />,
  },
  {
    path: "/hipobuy-vs-superbuy",
    element: <HipobuyVsSuperbuy />,
  },
  {
    path: "/hipobuy-vs-oopbuy",
    element: <HipobuyVsOopbuy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;